export default {
  project: {
    save: 'pms/project/save.json',
    delete: 'pms/project/delete.json',
    search: 'pms/project/search.json',
    info: 'pms/project/info.json',
    tables: 'pms/project/tables.json',
    generateCode: 'pms/project/generate.json',
    autocomplete: 'pms/project/autocomplete.json',
    projectItem:'pms/sheet/item/projectItem.json'
  },
  plan: {
    save: 'pms/plan/save.json',
    delete: 'pms/plan/delete.json',
    search: 'pms/plan/search.json',
    info: 'pms/plan/info.json',
    searchByPorject: 'pms/plan/searchby/project.json'
  },
  sheet: {
    save: '/pms/sheet/save.json',
    delete: 'pms/sheet/delete.json',
    search: 'pms/sheet/search.json',
    info: 'pms/sheet/info.json',
    my: 'pms/sheet/my.json'
  },
  sheetItem: {
    save: 'pms/sheet/item/save.json',
    delete: 'pms/sheet/item/delete.json',
    search: 'pms/sheet/item/search.json',
    info: 'pms/sheet/item/info.json',
    sheet: 'pms/sheet/item/sheet.json'
  },
  period: {
    save: 'pms/period/save.json',
    delete: 'pms/period/delete.json',
    search: 'pms/period/search.json',
    info: 'pms/period/info.json'
  },
  home: {
    projectConsume: 'pms/home/projectConsume.json',
    projectProper: 'pms/home/projectProper.json',
    projectHour: 'pms/home/projectHour.json',
    projectConsumeHour: 'pms/home/projectConsumeHour.json',
    projectHourMonth: 'pms/home/projectHourMonth.json',
    projectConsumeMonth: 'pms/home/projectConsumeMonth.json',
    projectJobConsume: 'pms/home/projectJobConsume.json',
    jobConsumeMonth: 'pms/home/jobConsumeMonth.json',
    projectJobHour: 'pms/home/projectJobHour.json',
    employeeProject: 'pms/home/employeeProject.json',
    employeeConsumeProject: 'pms/home/employeeConsumeProject.json',
    historicalProject: 'pms/home/historicalProject.json',
    detailConsumeAdd: 'pms/home/detailConsumeAdd.json'
  },

  tools: {
    healthGenerateSheet: 'pms/tools/health/generateSheet.json'
  }
};
